import * as React from 'react';
import * as styles from './styles.css';
import { RadioButton } from '@cian/ui-kit';

import { EExtendsOptions, EPreciseFilterValues } from '../../../../types/redux/preciseFilters';
import { IOptionsRendererProps } from '../../types';

export const RadioGroupRenderer: React.FC<IOptionsRendererProps> = props => {
  const { options, onChange, filterName, disabled, filterState } = props;

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value as EPreciseFilterValues;

    onChange(value);
  };

  return (
    <ul className={styles['container']}>
      {options.map(option => {
        const isChecked =
          filterState.includes(option.name) || (filterState.length === 0 && option.name === EExtendsOptions.Reset);
        const isDisabled = !isChecked && disabled;

        return (
          <li key={option.name} className={styles['option']}>
            <RadioButton
              name={String(filterName)}
              value={option.name}
              onChange={handleValueChange}
              checked={isChecked}
              label={option.displayName}
              disabled={isDisabled}
            />
          </li>
        );
      })}
    </ul>
  );
};

RadioGroupRenderer.displayName = 'RadioGroupRenderer';
